export function relatedLinks() {
    const $equalHeights = $('.u-node-equal-heights');

    $equalHeights.matchHeight();

    $(window).resize(function () {
        $equalHeights.css('height', '').matchHeight();
    });
}
